@use '@srm/ui/styles/mixins' as *;

/* Стабильный триггер-обёртка: размер строго по аватару, без трансформаций —
   Floating UI привязывает карточку к нему, поэтому масштаб аватара её не двигает. */
.user-hcard__anchor {
    display: inline-flex;
    line-height: 0;
}
/* Текстовый триггер (<UserName>): anchor течёт как обычный inline-текст —
   подчёркивание и перенос строки работают штатно, базовая линия совпадает с соседним текстом. */
.user-hcard__anchor--inline {
    display: inline;
    line-height: inherit;
}

/* Hover-карточка пользователя (контакты). Палитра — переменные colors.scss. */
.user-hcard {
    /* чернила бейджей, для которых в палитре нет ступени: индиго RPA и янтарь ВРИО;
       в тёмной — светлые ступени рампы */
    --hcard-rpa-ink: #5646d6;
    --hcard-rpa-tint: #ecebff;
    --hcard-vrio-ink: #8a6d00;

    font-family: var(--font-family);
    color: var(--neutral-90);
    padding: 0;
    /* обрезаем по скруглению — полоса-акцент ложится ровно по верхним углам (как spine в NotificationDropdown) */
    overflow: hidden;
    /* высокая карточка (руководитель + участники) не вылезает за экран — внутренний скролл */
    display: flex;
    flex-direction: column;
    max-height: min(72vh, 560px);
    /* без 1px-рамки Mantine — иначе над полосой-акцентом виден белый край; карточку держит тень */
    border: none;

    @include dark {
        --hcard-rpa-ink: var(--purple-70);
        --hcard-rpa-tint: var(--purple-10);
        --hcard-vrio-ink: var(--attention-60);
    }
}
/* Прокручиваемая область; полоса-акцент (::before у .user-hcard) остаётся зафиксированной сверху. */
.user-hcard__scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 14px 16px;
    scrollbar-width: thin;
    scrollbar-color: var(--grid-scrollbar-color) transparent;
}

.user-hcard__head {
    display: flex;
    align-items: center;
    gap: 12px;
}
.user-hcard__id {
    min-width: 0;
}
.user-hcard__name {
    font-size: var(--fz-14);
    font-weight: var(--fw-500);
    color: var(--neutral-90);
    line-height: var(--lh-tight);
}
/* Строка имени — ФИО + иконка типа служебной УЗ (интеграционная / робот). */
.user-hcard__name-row {
    display: flex;
    align-items: center;
    gap: 6px;
}
.user-hcard__name-row .user-hcard__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Тихая служебная метка: мягкий фон, тонированная иконка. Показываем только у ботов. */
.user-hcard__uz {
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    cursor: default;
}
.user-hcard__uz svg {
    width: 14px;
    height: 14px;
}
/* Интеграционная — бирюза (обмен между системами). */
.user-hcard__uz--int {
    color: var(--teal-60-main);
    background: var(--teal-10);
}
/* Роботизированная — индиго (RPA); готового токена нет — литерал (--hcard-rpa-*), как у ВРИО. */
.user-hcard__uz--rpa {
    color: var(--hcard-rpa-ink);
    background: var(--hcard-rpa-tint);
}
.user-hcard__post {
    font-size: var(--fz-12);
    color: var(--neutral-60);
    margin-top: 2px;
}
/* Чип состояния учётной записи в шапке — один по приоритету (Уволен → Деактивирован → В отпуске). */
.user-hcard__state {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    font-size: var(--fz-10);
    font-weight: var(--fw-600);
    letter-spacing: var(--ls-normal);
    line-height: var(--lh-text);
    border-radius: 8px;
    padding: 2px 8px 2px 6px;
}
.user-hcard__state svg {
    flex: none;
}
/* Уволен — красный (финальное состояние). */
.user-hcard__state--dismissed {
    color: var(--error-60-main);
    background: var(--error-10);
    border: 1px solid var(--error-20);
}
/* Деактивирован — нейтральный серый (учётка не активна). */
.user-hcard__state--deactivated {
    color: var(--neutral-60);
    background: var(--neutral-05);
    border: 1px solid var(--neutral-20);
}
/* В отпуске — спокойный синий (временно отсутствует, не тревога). */
.user-hcard__state--vacation {
    color: var(--primary-70);
    background: var(--primary-10);
    border: 1px solid var(--primary-20);
}

.user-hcard__rows {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid var(--neutral-10);
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.user-hcard__row {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: var(--fz-12);
    color: var(--neutral-70);
    overflow-wrap: anywhere;
}
.user-hcard__row-ic {
    flex-shrink: 0;
    color: var(--neutral-40);
    display: inline-flex;
}
.user-hcard__row-link {
    color: var(--primary-70);
    text-decoration: none;
}
.user-hcard__row-link:hover {
    text-decoration: underline;
}

.user-hcard__members-label {
    font-size: var(--fz-10);
    text-transform: uppercase;
    letter-spacing: var(--ls-caps);
    color: var(--neutral-50);
    margin-bottom: 2px;
}

.user-hcard__members-more {
    font-size: var(--fz-12);
    color: var(--neutral-50);
    padding-left: 23px;
}

/* Имя участника в списке состава группы — триггер вложенной hover-карточки.
   Пунктир появляется на hover (как у UserName), курсор обычный. */
.user-hcard__member-name {
    font-size: var(--fz-13);
    font-weight: var(--fw-500);
    color: var(--neutral-90);
    line-height: var(--lh-tight);
    text-decoration: underline dotted transparent;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
    transition: text-decoration-color 0.15s ease;
}
.user-hcard__member-name:hover {
    text-decoration-color: currentColor;
}

/* Строка-персона (руководитель / участник / заместитель): аватар + имя (+подпись) + бейдж. */
.user-hcard__pline {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 6px;
    border-radius: 9px;
    transition: background 0.12s ease;
}
.user-hcard__pline:hover {
    background: var(--neutral-05);
}
.user-hcard__pline-who {
    min-width: 0;
    flex: 1;
}
.user-hcard__pline-meta {
    font-size: var(--fz-11);
    color: var(--neutral-50);
    margin-top: 1px;
    line-height: var(--lh-tight);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* Руководитель выделен мягким бирюзовым тоном (акцент типа «группа»). */
.user-hcard__pline--lead {
    background: color-mix(in srgb, var(--teal-50) 7%, transparent);
}
.user-hcard__pline--lead:hover {
    background: color-mix(in srgb, var(--teal-50) 12%, transparent);
}

/* Бейджи заместителей. */
.user-hcard__badge {
    flex: none;
    align-self: center;
    font-size: var(--fz-10);
    font-weight: var(--fw-600);
    border-radius: 7px;
    padding: 2px 8px;
    white-space: nowrap;
}
.user-hcard__badge--perm {
    color: var(--success-60);
    background: var(--success-10);
    border: 1px solid var(--success-20);
}
/* ВРИО — янтарный; тёмный текст #8a6d00 читаем на attention-10 (готового токена в палитре нет). */
.user-hcard__badge--vrio {
    color: var(--hcard-vrio-ink);
    background: var(--attention-10);
    border: 1px solid var(--attention-20);
}

/* Кнопка «Показать всех N» — вход в модалку с полным списком участников. */
.user-hcard__show-all {
    margin-top: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 12px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-family: var(--font-family);
    font-size: var(--fz-12);
    font-weight: var(--fw-600);
    color: var(--primary-70);
    background: var(--primary-10);
    transition: background 0.13s ease;
}
.user-hcard__show-all:hover {
    background: var(--primary-20);
}

/* ——— Доводка под макет (прототип = эталон) ——— */

/* Полоса-акцент типа сверху карточки: человек — синий, группа — бирюза.
   Дропдаун уже позиционирован (Floating UI) → ::before якорится к нему. */
.user-hcard::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    z-index: 2; /* поверх прокручиваемого содержимого; обрезку углов даёт overflow:hidden карточки */
    pointer-events: none;
}
.user-hcard--person::before {
    background: linear-gradient(90deg, var(--primary-50), var(--primary-60-main));
}
.user-hcard--group::before {
    background: linear-gradient(90deg, var(--teal-40), var(--teal-60-main));
}

/* Кольцо-обводка главного аватара (только в шапке): цвет по типу. */
.user-hcard__head .rf-user-avatar {
    box-shadow:
        0 0 0 3px var(--neutral-00),
        0 0 0 4px var(--user-hcard-ring, transparent);
}
.user-hcard--person .user-hcard__head .rf-user-avatar {
    --user-hcard-ring: var(--primary-20);
}
.user-hcard--group .user-hcard__head .rf-user-avatar {
    --user-hcard-ring: var(--teal-20);
}

/* Подпись типа группы (рабочая группа/подразделение) — заглавные, бирюза. */
.user-hcard__type {
    font-size: var(--fz-11);
    font-weight: var(--fw-600);
    letter-spacing: var(--ls-caps);
    text-transform: uppercase;
    color: var(--teal-70);
    margin-top: 3px;
}

/* Счётчик в метке «УЧАСТНИКИ · N» — приглушённый. */
.user-hcard__members-count {
    color: var(--neutral-40);
}

/* Строки-персоны идут плотно (как в макете) — снимаем общий gap контейнера. */
.user-hcard__rows--people {
    gap: 0;
}
.user-hcard__rows--people .user-hcard__members-label {
    margin-bottom: 8px;
}

/* Стрелка на кнопке «Показать всех» — сдвигается на hover. */
.user-hcard__show-all-arr {
    transition: transform 0.15s ease;
}
.user-hcard__show-all:hover .user-hcard__show-all-arr {
    transform: translateX(3px);
}
@media (prefers-reduced-motion: reduce) {
    .user-hcard__show-all-arr {
        transition: none;
    }
}
